import type { ICandidateWidget } from "../ICandidateWidget";
import { getCandidateColumns } from "../table/CandidateColumns";

/**
 * Restituisce le colonne selezionate nel widget candidato
 */
export function getWidgetCandidateColumns(widget: ICandidateWidget) {
	return getCandidateColumns(widget.columns);
}
